import { useContext } from "react";
import { PageNewState, CommentDialogContext } from ".";

export const useCommentDialogState = () => {
  const { pageState, setPageState } = useContext(CommentDialogContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
